import { appManager, AppState } from '../manager';
import type { IntradayFetchSnapshot } from './types';

const makeFetchStatus = (mode: 'intraday' | 'eod') =>
  appManager.createApi<
    { request_id: number; invalidate?: boolean },
    IntradayFetchSnapshot,
    AppState
  >(`FETCH_${mode.toUpperCase()}_FETCH_STATUS`, {
    path: `/admin/${mode}_fetch_status`,
    method: 'GET',
    startReducer(state, payload) {
      const status = state[`${mode}_fetch_status`];
      status.loading = true;
      status.request_id = payload.request_id;
      status.error = undefined;
      if (payload.invalidate) status.snapshot = undefined;
    },
    successReducer(state, snapshot, payload) {
      const status = state[`${mode}_fetch_status`];
      if (status.request_id !== payload.request_id) return;
      status.loading = false;
      if (
        !status.snapshot ||
        Date.parse(snapshot.computed_at) >=
          Date.parse(status.snapshot.computed_at)
      ) {
        status.snapshot = snapshot;
      }
      status.error = undefined;
    },
    failReducer(state, _error, payload) {
      const status = state[`${mode}_fetch_status`];
      if (status.request_id !== payload.request_id) return;
      status.loading = false;
      status.error = `${mode === 'intraday' ? 'Intraday' : 'EoD'} status could not be refreshed.`;
    },
  });

export const fetchIntradayFetchStatus = makeFetchStatus('intraday');
export const fetchEodFetchStatus = makeFetchStatus('eod');
